import { useMemo } from 'react';
import { CodeListInput } from './CodeListInput';
import { CountrySelect } from './CountrySelect';
import { useLookup } from '@/hooks/useLookups';

export interface CountryListInputProps {
  /** La liste telle qu'elle est stockee : un tableau de codes ISO. */
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  id?: string;
}

/**
 * Liste de pays choisis dans le menu ordinaire (#228) — meme filtre au
 * clavier, memes drapeaux que partout ailleurs. Le selecteur sert de bouton
 * d'ajout et ne retient jamais de valeur.
 *
 * Les noms viennent du meme referentiel que le selecteur (#222) : une liste
 * tenue a la main derivait de la table `country`.
 */
export function CountryListInput({
  value,
  onChange,
  placeholder = 'Add a country…',
  error,
  disabled,
  id,
}: CountryListInputProps) {
  const { items: countries } = useLookup('countries');
  const labelByCode = useMemo(
    () => new Map(countries.map((c) => [c.code ?? '', c.label])),
    [countries],
  );

  return (
    <CodeListInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      id={id}
      labelFor={(code) => labelByCode.get(code)}
      picker={(add) => (
        <CountrySelect
          id={id}
          value={undefined}
          onChange={add}
          placeholder={placeholder}
          error={error}
          disabled={disabled}
        />
      )}
    />
  );
}
